import React, { useEffect, useState } from 'react';

import DropdownSelector from './dropdowns/DropdownSelector';
import PartnerCompanyBranchService from '../services/PartnerCompanyBranch';
import { REQUEST_PARAMS } from '../utilities/constants';

export const DEFAULT_PARAMS = {
  block_flags: [false],
  order: 'block_flag_asc',
};
export const HEAD_OFFICE_OPTION = {
  id: 'HEAD_OFFICE_OPTION_ID',
  name: '本社',
};

export const PartnerCompanyBranchDropdown = ({
  selectedCompanyId,
  selectedPartnerCompanyBranchId,
  onSelect,
  params,
  disabled,
  previewValue,
  clearFlag,
  ...restProps
}) => {
  const [selectedName, setName] = useState(null);

  useEffect(() => {
    setName(previewValue || '');
  }, []);

  if (disabled) {
    return <span>{previewValue || HEAD_OFFICE_OPTION.name}</span>;
  }

  const selectedValues = selectedPartnerCompanyBranchId
    ? String(selectedPartnerCompanyBranchId)
    : '';

  if (selectedName === null) {
    return null;
  }

  return (
    <DropdownSelector
      label='支店を選択'
      selectorName='name'
      api={params =>
        PartnerCompanyBranchService.partnerCompanyBranchList(
          selectedCompanyId,
          params
        )
      }
      apiParams={{
        ...DEFAULT_PARAMS,
        ...params,
      }}
      apiSearchKey='name'
      selectedValues={selectedValues}
      limit={REQUEST_PARAMS.parentLimitPartnerCompanyBranchDropdown}
      selectedName={selectedName}
      keyName='name'
      valueName='id'
      apiBindDataKey='partner_company_branches'
      onSelect={(name, values, valueName) => {
        onSelect(values, name, valueName);
        setName(valueName);
      }}
      isOptional={false}
      strictEqual={true}
      reloadOptions={false}
      dropdownSelectStyle={{ width: '238px' }}
      clearFlag={clearFlag}
      {...restProps}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/PartnerCompanyBranchDropdown.jsx